import React from "react";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import { VendorInput } from "../../../input/VendorInput/VendorInput";

interface ExclusionSectionProps {
  selectedVendorIds: number[];
  onVendorSelect: (vendorIds: number[]) => void;
}

export const ExclusionSection: React.FC<ExclusionSectionProps> = React.memo(
  ({ selectedVendorIds, onVendorSelect }) => {
    return (
      <Paper
        elevation={0}
        sx={{
          p: 2,
          mb: 2,
          border: "1px solid",
          borderColor: "divider",
          borderRadius: 2,
        }}
      >
        <Stack
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          mb={1}
        >
          <Typography variant="body1">
            <Box component="span" fontWeight="bold">
              Exclude
            </Box>{" "}
            companies using{" "}
            <Box component="span" fontWeight="bold">
              any
            </Box>{" "}
            of the following vendors
          </Typography>
        </Stack>
        <VendorInput
          onVendorsSelect={(value) =>
            onVendorSelect(value.map((v) => Number(v.value)))
          }
          selectedVendorIds={selectedVendorIds}
        />
      </Paper>
    );
  }
);
